var React = require('react');

function ScrollInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_1","data-name":"Group 1","transform":"translate(-582 -311)"},[React.createElement("g",{"id":"next","transform":"translate(605 311) rotate(90)","key":0},React.createElement("path",{"id":"Shape","d":"M11.208,8.622,2.8,0,0,2.867,8.406,11.5,0,20.133,2.8,23l8.406-8.622L14,11.5,11.208,8.622Z","fill":"#333"})),React.createElement("g",{"id":"next-2","data-name":"next","transform":"translate(605 321) rotate(90)","key":1},React.createElement("path",{"id":"Shape-2","data-name":"Shape","d":"M11.208,8.622,2.8,0,0,2.867,8.406,11.5,0,20.133,2.8,23l8.406-8.622L14,11.5,11.208,8.622Z","fill":"#333"}))]));
}

ScrollInline.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 23 24"};

module.exports = ScrollInline;

ScrollInline.default = ScrollInline;
